module.exports = __webpack_public_path__ + "media/images/home/orange_arrow-42642bd7616e0ac246a0341c4ec2ba96.svg";